import { Link2 } from 'lucide-react';
import { useState } from 'react';

import { Share } from '@/components/modules/share';
import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog';
import { useShareItem } from '@/hooks/use-share-item';
import { SHARED_ITEM_TYPE } from '@/lib/constants';
import { SharedItemType } from '@/lib/models/shared-item/types';
import { trackUser } from '@/utils/tracking';

export interface ShipmentShareProps {
  shipmentId: string;
  isOpen?: boolean;
  shareUrlOverride?: string;
  type: SharedItemType;
}

const ShipmentShare = ({
  shipmentId,
  isOpen: isOpenProp,
  type = SHARED_ITEM_TYPE.SHIPMENT,
  shareUrlOverride,
}: ShipmentShareProps) => {
  const [isOpen, setIsOpen] = useState(isOpenProp || false);

  const handleOpenChange = (value: boolean) => {
    if (value) {
      trackUser.event(`User opened shipment sharing for ${type}`);
    }
    setIsOpen(value);
  };

  const { sharedItem, updateSharedItem, isLoading, error } = useShareItem({
    type,
    isEnabled: isOpen,
    itemId: shipmentId,
  });

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>
        <button
          type="button"
          className="flex items-center text-baseSm text-lightBlue-600 underline-offset-2 hover:underline"
        >
          Share
          <Link2 size={16} className="ml-1.5" />
        </button>
      </DialogTrigger>
      <DialogContent className="min-h-24" onClose={() => setIsOpen(false)}>
        <Share
          sharedItem={sharedItem}
          isLoading={isLoading}
          onUpdate={updateSharedItem}
          error={error}
          shareUrlOverride={shareUrlOverride}
          heading="Share shipment"
        />
      </DialogContent>
    </Dialog>
  );
};

export { ShipmentShare };
